// 设备管理相关API服务
import { httpClient } from '../http';
import {
  DeviceListItem,
  DeviceDetail,
  DeviceListParams,
  PaginationResponse,
  UpgradeReport,
} from '@/types/api';

export class DevicesAPI {
  // 获取设备列表
  async getDevices(params?: DeviceListParams): Promise<PaginationResponse<DeviceListItem>> {
    const response = await httpClient.get<PaginationResponse<DeviceListItem>>('/admin/devices', params);
    return response.data;
  }

  // 获取设备详情
  async getDeviceById(id: number): Promise<DeviceDetail> {
    const response = await httpClient.get<DeviceDetail>(`/admin/devices/${id}`);
    return response.data;
  }

  // 获取设备升级日志
  async getDeviceUpgradeLogs(id: number, toVersion?: string): Promise<UpgradeReport[]> {
    const params = toVersion ? { to_version: toVersion } : undefined;
    const response = await httpClient.get<UpgradeReport[]>(`/admin/devices/${id}/upgrade-logs`, params);
    return response.data;
  }
}

// 导出单例实例
export const devicesAPI = new DevicesAPI();
